import { render, staticRenderFns } from "./cart-tabs.vue?vue&type=template&id=4d606ebe&scoped=true&"
import script from "./cart-tabs.vue?vue&type=script&lang=js&"
export * from "./cart-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d606ebe",
  null
  
)

export default component.exports